// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"eb553a01","317":"673b8849","413":"1ead50a2","917":"4cbe96b1"}[chunkId] + ".chunk.js";
};